// ----------------------------------------------
// ----------------------------------------------

// custom video player script for acf/video-player block
jQuery(document).ready(function ($) {
  $('video').on({
    play: function () { // the video is playing!      
      $(this).closest('.video-player-wrapper').addClass('js-playing');
    },
    pause: function () { // the video is paused!
      $(this).closest('.video-player-wrapper').removeClass('js-playing');
    },
  })

  $('.js-video').each(function () {
    var currentVideo = $(this);
    var durationBar = $(this).siblings('.js-video-controls').find('.js-video-duration');
    currentVideo[0].addEventListener('loadedmetadata', function () {
      var duration = currentVideo[0].duration;
      var durationMinutes = Math.floor(duration / 60);
      var durationSeconds = Math.floor(duration - durationMinutes * 60)
      var durMins = durationMinutes < 10 ? "" + durationMinutes : durationMinutes;
      var durSecs = durationSeconds < 10 ? "0" + durationSeconds : durationSeconds;
      durationBar[0].innerHTML = '<span class="bar-wrapper"><span class="bar"></span><span class="time-wrapper"><span class="current">0:00</span> / <span class="duration">' + durMins + ':' + durSecs + '</span></span></span>';
    });
  });

  $('.js-video').each(function () {
    $(this).on(
      "timeupdate",
      function (event) {
        // onTrackedVideoFrame(this.currentTime, this.duration);
        var currentVideo = $(this);
        var durationBar = $(this).siblings('.js-video-controls').find('.js-video-duration');

        var current = currentVideo[0].currentTime;
        var currentMinutes = Math.floor(current / 60);
        var currentSeconds = Math.floor(current - currentMinutes * 60)
        var curMins = currentMinutes < 10 ? "" + currentMinutes : currentMinutes;
        var curSecs = currentSeconds < 10 ? "0" + currentSeconds : currentSeconds;

        var duration = currentVideo[0].duration;
        var durationMinutes = Math.floor(duration / 60);
        var durationSeconds = Math.floor(duration - durationMinutes * 60)
        var durMins = durationMinutes < 10 ? "" + durationMinutes : durationMinutes;
        var durSecs = durationSeconds < 10 ? "0" + durationSeconds : durationSeconds;

        durationBar[0].innerHTML = '<span class="bar-wrapper"><span class="bar"></span><span class="time-wrapper"><span class="current">' + curMins + ':' + curSecs + '</span> / <span class="duration">' + durMins + ':' + durSecs + '</span></span></span>';

        var barLength = ((current / duration) * 100).toFixed(0);
        // console.log(barLength);
        durationBar.find('.bar').css('width', barLength + '%');

        currentVideo.on('ended', function () {
          $(this).next('.js-video-controls').find('.js-video-play-button').html('Play');
        });

      });
  });

  $('.js-video-play-button').click(function () {
    var currentVideo = $(this).closest('.js-video-controls').siblings('.js-video');
    currentVideo[0].paused ? currentVideo[0].play() : currentVideo[0].pause();
    if (currentVideo.get(0).paused) {
      $(this).html('Play');
    } else {
      $(this).html('Pause');
    };
  });

  $('.js-video-overlay-play-button').click(function () {
    var currentVideo = $(this).closest('.js-video-controls').siblings('.js-video');
    currentVideo[0].paused ? currentVideo[0].play() : currentVideo[0].pause();
    if (currentVideo.get(0).paused) {
      $(this).next().html('Play');
    } else {
      $(this).next().html('Pause');
    };
  });

  $('.js-video-volume-button').click(function () {
    var currentVideo = $(this).closest('.js-video-controls').siblings('.js-video');
    $(currentVideo).prop('muted', !$(currentVideo).prop('muted'));
  });

  $('.js-video-fullscreen-button').click(function () {
    var currentVideo = $(this).closest('.js-video-controls').siblings('.js-video');
    if (currentVideo[0].requestFullscreen) {
      currentVideo[0].requestFullscreen();
    } else if (currentVideo[0].mozRequestFullScreen) {
      currentVideo[0].mozRequestFullScreen();
    } else if (currentVideo[0].webkitRequestFullScreen) {
      currentVideo[0].webkitRequestFullScreen();
    } else if (currentVideo[0].msRequestFullscreen) {
      currentVideo[0].msRequestFullscreen();
    }
  });
});

// ----------------------------------------------
// ----------------------------------------------

// main menu functionality
jQuery(document).ready(function ($) {

  // menu / back button. It's only one button, the chaning text in the button comes from before/after pseudo classes in the css
  $('.js-main-menu-button').on('click', function () {
    // check if we are in an open sub menu    
    if ($('body').hasClass('js-main-menu-sub-menu-open')) {
      // if so, close the open sub menu, but do nothing else, i.e. the main menu stays open & is fully displayed again
      $('body').removeClass('js-main-menu-sub-menu-open');
      $('.menu-item-has-children').each(function () {
        $(this).removeClass('js-sub-menu-open');
      });
    }
    // if not in an open sub menu:
    else {
      // check if main menu is open
      if ($('body').hasClass('js-main-menu-open')) {
        // if so, close it, and also close all sub menus
        $('body').removeClass('js-main-menu-open');
        $('body').removeClass('js-main-menu-sub-menu-open');
        $('.menu-item-has-children').each(function () {
          $(this).removeClass('js-sub-menu-open');
        });
      }
      // if not open, open it
      else {
        $('body').addClass('js-main-menu-open');
      }
    }

  });

  // sub menu functionality. on click of parent li element that has children
  // it's recommended to use "#" in URL field when adding the parent as a custom link in the WP backend menu editor
  $('.menu-item-has-children > a').on('click', function (e) {
    // first, we prevent the default 
    e.preventDefault();
    // add body class to apply css changes of open sub menu. has to go into the body because we are hidding list elements outside of this
    $('body').addClass('js-main-menu-sub-menu-open');
    // add class to parent to open this element's sub menu
    $(this).closest('.menu-item-has-children').addClass('js-sub-menu-open');
  });

  // Search Focus
  $(".search-trigger").click(function () {
    document.getElementById("s").focus();
  });
});

// ----------------------------------------------
// ----------------------------------------------

// detect dark or light mode and change body's data-theme attribute accordingly

jQuery(document).ready(function ($) {

  var flipped = false;
  if ($('body').hasClass('js-dark-light-flipped')) {
    flipped = true;
  };

  function setColorScheme(scheme) {
    switch (scheme) {
      case 'dark':
        // Dark
        $('body').attr('data-theme', 'numerodark');
        break;
      case 'light':
        // Light
        $('body').attr('data-theme', 'numero');
        break;
      default:
        // Default
        $('body').attr('data-theme', 'numero');
        break;
    }
  }

  function getPreferredColorScheme() {
    if (window.matchMedia) {
      if (!flipped == true) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
          return 'dark';
        } else {
          return 'light';
        }
      }
      else { // if flipped
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
          return 'light';
        } else {
          return 'dark';
        }
      }
    }
    return 'light';
  }

  if (window.matchMedia) {
    var preferredColorScheme = getPreferredColorScheme();
    var colorSchemeQuery = window.matchMedia('(prefers-color-scheme: ' + preferredColorScheme + ')');
    colorSchemeQuery.addEventListener('change', setColorScheme(getPreferredColorScheme()));
  }

});

// ----------------------------------------------
// ----------------------------------------------


// Shop Item Shadow from Kolja
// (function() {
//   var cx, cy, h1, setOffsets;

//   h1 = $('img.moving-shadow');

//   cx = cy = 0;

//   setOffsets = function() {
//     cx = h1.offset().left + h1.width() / 2;
//     return cy = h1.offset().top + h1.height() / 2;
//   };

//   $(window).on({
//     'mousemove': function(e) {
//       var dx, dy, mx, my;
//       mx = e.clientX;
//       my = e.clientY;
//       dx = cx - mx;
//       dy = cy - my;
//       console.log(mx, my, cx, cy);
//       return h1.css('box-shadow', `${dx / 20}px ${dy / 10}px 60px rgba(0,0,0,0.5)`);
//     },
//     'load': setOffsets,
//     'resize': setOffsets
//   });

// }).call(this);